import { useAppSelector } from 'application/providers/StoreProvider';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyRequisite = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectCompanyRequisite);
};
